/**
 * @param {Array} data 待处理的数据
 * @param {Number} type 待处理的数据来源 0 tv 1 v
 */
const handleVideoStream = (data, type) => {
    const toLink = ['//tv.ifeng.com/c/', '//v.ifeng.com/c/'];

    try {
        return data.map(item => ({
            posterUrl: item.posterUrl,
            title: item.title,
            columnName: item.columnName || item.wemediaEAccountName,
            newsTime: item.newsTime,
            duration: item.duration,
            guid: item.guid,
            base62Id: item.base62Id,
            url: item.url, // item.base62Id ? `${toLink[type]}${item.base62Id}` : item.url,
            type: item.type,
            thumbnail: item.posterUrl,
            commentUrl: item.commentUrl,
        }));
    } catch (e) {
        console.error(e);
    }
};

export { handleVideoStream };
